import './expo_page.css';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate

import { useTranslation } from 'react-i18next';

function Garage() {

    const { t } = useTranslation();
    const navigate = useNavigate(); // Create a navigate function

    const user = JSON.parse(localStorage.getItem('user'));
    const username = user ? user.username : null;

    const handleButtonClickDown = () => {
        navigate('/area_download'); // Navigate to the link corresponding to the current image
    };

    const handleButtonClickWms = () => {
        navigate('/wms'); // Navigate to the link corresponding to the current image
    };

    const handleButtonClickcore = () => {
        navigate('/software'); // Navigate to the link corresponding to the current image
    };

    const handleButtonClickShapp = () => {
        navigate('/sHapp'); // Navigate to the link corresponding to the current image
    };

    const handleButtonClickelab = () => {
        navigate('/shapp_insdata'); // Navigate to the link corresponding to the current image
    };

    const handleButtonClickHelp = () => {
        navigate('/Ticket'); // Navigate to the link corresponding to the current image
    };

    const handleButtonClickArck = () => {
        navigate('/archive'); // Navigate to the link corresponding to the current image
    };

    const handleButtonClickBill = () => {
        navigate('/billing'); // Navigate to the link corresponding to the current image
    };

    return(
        <div className="main-wrapper">
            <div className="tools-wrapperS1" id="id1">
                <div className="title-sez1">V.E.S.</div>
                <div className="sez1" >
                    <div className="bloc-cont">
                        <div className="ic1" onClick={handleButtonClickShapp} style={{ cursor: 'pointer' }}>
                            <div className="ic1-block">
                                <h3 className="preview-title">Database prove</h3>
                            </div>
                            <div className="ic1-block">
                                   <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                                      <path strokeLinecap="round" strokeLinejoin="round" d="M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375m16.5 0v3.75m-16.5-3.75v3.75m16.5 0v3.75C20.25 16.153 16.556 18 12 18s-8.25-1.847-8.25-4.125v-3.75m16.5 0c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125" />
                                   </svg>
                            </div>
                            <div className="ic1-block">
                            </div>
                        </div>
                        <div className="ic1" onClick={handleButtonClickcore} style={{ cursor: 'pointer' }}>
                            <div className="ic1-block">
                                <h3 className="preview-title">Strumenti</h3>
                            </div>
                            <div className="ic1-block">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                                      <path strokeLinecap="round" strokeLinejoin="round" d="M11.42 15.17 17.25 21A2.652 2.652 0 0 0 21 17.25l-5.877-5.877M11.42 15.17l2.496-3.03c.317-.384.74-.626 1.208-.766M11.42 15.17l-4.655 5.653a2.548 2.548 0 1 1-3.586-3.586l6.837-5.63m5.108-.233c.55-.164 1.163-.188 1.743-.14a4.5 4.5 0 0 0 4.486-6.336l-3.276 3.277a3.004 3.004 0 0 1-2.25-2.25l3.276-3.276a4.5 4.5 0 0 0-6.336 4.486c.091 1.076-.071 2.264-.904 2.95l-.102.085m-1.745 1.437L5.909 7.5H4.5L2.25 3.75l1.5-1.5L7.5 4.5v1.409l4.26 4.26m-1.745 1.437 1.745-1.437m6.615 8.206L15.75 15.75M4.867 19.125h.008v.008h-.008v-.008Z" />
                                    </svg>

                            </div>
                            <div className="ic1-block">
                            </div>
                        </div>

                        <div className="ic1" onClick={handleButtonClickelab} style={{ cursor: 'pointer' }}>
                            <div className="ic1-block">
                                <h3 className="preview-title">Progetti sHnapp</h3>
                            </div>
                            <div className="ic1-block">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                                      <path strokeLinecap="round" strokeLinejoin="round" d="M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5" />
                                    </svg>

                            </div>
                            <div className="ic1-block">
                            </div>
                        </div>

                        <div className="ic1" onClick={handleButtonClickHelp} style={{ cursor: 'pointer' }}>
                            <div className="ic1-block">
                                <h3 className="preview-title">Assistenza</h3>
                            </div>
                            <div className="ic1-block">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                                      <path strokeLinecap="round" strokeLinejoin="round" d="M8.625 9.75a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 0 1 .778-.332 48.294 48.294 0 0 0 5.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z" />
                                    </svg>
                            </div>
                            <div className="ic1-block">
                            </div>
                        </div>
                     </div>
                </div>
            </div>

            <div className="tools-wrapperS2" id="id2">
                <div className="sez2" >
                    <div className="bloc-cont">
                        <div className="ic1" onClick={handleButtonClickArck} style={{ cursor: 'pointer' }}>
                            <div className="ic1-block">
                                <h3 className="preview-title">Archivio</h3>
                            </div>
                            <div className="ic1-block">
                                   <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                                      <path strokeLinecap="round" strokeLinejoin="round" d="m7.875 14.25 1.214 1.942a2.25 2.25 0 0 0 1.908 1.058h2.006c.776 0 1.497-.4 1.908-1.058l1.214-1.942M2.41 9h4.636a2.25 2.25 0 0 1 1.872 1.002l.164.246a2.25 2.25 0 0 0 1.872 1.002h2.092a2.25 2.25 0 0 0 1.872-1.002l.164-.246A2.25 2.25 0 0 1 16.954 9h4.636M2.41 9a2.25 2.25 0 0 0-.16.832V12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 12V9.832c0-.287-.055-.57-.16-.832M2.41 9a2.25 2.25 0 0 1 .382-.632l3.285-3.832a2.25 2.25 0 0 1 1.708-.786h8.43c.657 0 1.281.287 1.709.786l3.284 3.832c.163.19.291.404.382.632M4.5 20.25h15A2.25 2.25 0 0 0 21.75 18v-2.625c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125V18a2.25 2.25 0 0 0 2.25 2.25Z" />
                                    </svg>
                            </div>
                            <div className="ic1-block">
                            </div>
                        </div>
                        <div className="ic1" onClick={handleButtonClickDown} style={{ cursor: 'pointer' }}>
                            <div className="ic1-block">
                                <h3 className="preview-title">App & Utilities</h3>
                            </div>
                            <div className="ic1-block">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                                      <path strokeLinecap="round" strokeLinejoin="round" d="M9 8.25H7.5a2.25 2.25 0 0 0-2.25 2.25v9a2.25 2.25 0 0 0 2.25 2.25h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25H15M9 12l3 3m0 0 3-3m-3 3V2.25" />
                                    </svg>
                            </div>
                            <div className="ic1-block">
                            </div>
                        </div>

                        <div className="ic1" onClick={handleButtonClickWms} style={{ cursor: 'pointer' }}>
                            <div className="ic1-block">
                                <h3 className="preview-title">Tile layer</h3>
                            </div>
                            <div className="ic1-block">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                                      <path strokeLinecap="round" strokeLinejoin="round" d="M9 6.75V15m6-6v8.25m.503 3.498 4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 0 0-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0Z" />
                                    </svg>
                            </div>
                            <div className="ic1-block">
                            </div>
                        </div>

                        <div className="ic1" onClick={handleButtonClickBill} style={{ cursor: 'pointer' }}>
                            <div className="ic1-block">
                                <h3 className="preview-title">Stato pagamenti</h3>
                            </div>
                            <div className="ic1-block">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                                      <path strokeLinecap="round" strokeLinejoin="round" d="M14.25 7.756a4.5 4.5 0 1 0 0 8.488M7.5 10.5h5.25m-5.25 3h5.25M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                                    </svg>
                            </div>
                            <div className="ic1-block">
                            </div>
                        </div>
                     </div>
                </div>
            </div>





      </div>

    );
}


export default Garage;

